import gql from 'graphql-tag'
import useMessage from '@hooks/useMessage'
import {deleteCartItemMutation} from '@data/mutations/cart/deleteCartItem'
import {useMutate} from '@packages/apollo-hooks'

export default function useDelete() {
  const mutate = useMutate()
  const showMessage = useMessage()
  return async cartItemId => {
    try {
      await mutate({
        mutation: deleteCartItemMutation,
        variables: {cartItemId},
        refetchQueries: ['getMyCart', 'getMyOrderPreferences', 'getCheckout']
      })
    } catch (error) {
      showMessage(error)
    }
  }
}
